module.exports = __webpack_public_path__ + "img/hr-light-mud-decal-29.3e832a14.png";